import { ICall } from '@/types';
import { cn } from '@/utils/utils';
import { ScrollArea } from '../ui/scroll-area';

const Transcript = ({ call }: { call: ICall }) => {
  if (!call?.transcript) return null;

  const sortedTranscript = [...call.transcript].sort((a: any, b: any) => {
    return (a.start || 0) - (b.start || 0);
  });

  const formatSeconds = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const formatSpeaker = (speaker: string): string => {
    return speaker === 'SPEAKER_00' ? 'Speaker 1' : 'Speaker 2';
  };

  return (
    <ScrollArea className="h-[calc(100vh-300px)] w-full py-4 px-2 pr-4">
      <div className="space-y-4">
        {sortedTranscript.map((entry: any, index: number) => {
          const speaker = entry.speaker || 'unknown';
          const isSpeakerOne = speaker === 'SPEAKER_00';

          return (
            <div key={index} className={`flex ${isSpeakerOne ? 'justify-start text-start' : 'justify-end text-right'}`}>
              <div className={`max-w-[80%] ${!isSpeakerOne ? 'bg-gray-300' : 'bg-gray-100'} rounded-lg p-3`}>
                <div className="flex items-center justify-between gap-2 mb-1">
                  <span className="text-sm font-semibold">{formatSpeaker(speaker)}</span>
                  {entry.start !== undefined && (
                    <span className="text-xs text-gray-500">{formatSeconds(entry.start)}</span>
                  )}
                </div>
                <p className={cn('text-sm')}>{entry.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </ScrollArea>
  );
};

export default Transcript;
